export default "__VITE_ASSET__BusE3f40__"